// Reveals all symbols in the grid by hiding all covers
export function revealAllSymbols(symbolManager) {
  if (!symbolManager || !symbolManager.symbols) return;
  for (const container of symbolManager.symbols) {
    if (container.cover) {
      container.cover.visible = false;
    }
  }
}
